import * as React from 'react';

import * as styles from './Pagination.css';
import { PaginationButton } from './PaginationButton';
import { IPaginationItem, IPaginationOnClickParams } from '../../types/pagination';

interface IPaginationProps {
  prevPage?: IPaginationItem;
  nextPage?: IPaginationItem;
  onClick(params: IPaginationOnClickParams): void;
  pages: IPaginationItem[];
}

export function Pagination({ onClick, pages, prevPage, nextPage }: IPaginationProps) {
  const handleClick = (e: React.SyntheticEvent<HTMLAnchorElement>, params: IPaginationOnClickParams) => {
    e.preventDefault();
    e.stopPropagation();

    if (onClick) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      onClick({ page: params.page, url: params.url });
    }
  };

  return (
    <nav className={styles['pagination']} data-mark="Pagination" data-testid="pagination">
      {prevPage && <PaginationButton {...prevPage} onClick={handleClick} />}
      <ul className={styles['pages-list']}>
        {pages.map(page => (
          <li className={styles['page']} key={page.page}>
            <PaginationButton {...page} onClick={handleClick} />
          </li>
        ))}
      </ul>
      {nextPage && <PaginationButton {...nextPage} onClick={handleClick} />}
    </nav>
  );
}
